var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
const SvgPlayButton = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 15,
    transform: "matrix(-1 0 0 1 30 0)",
    fill: "white",
    fillOpacity: 0.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.6309 10.0561C11.3523 9.89913 11 10.0901 11 10.3981V19.6019C11 19.9099 11.3523 20.1009 11.6309 19.9439L19.7952 15.3419C20.0683 15.188 20.0683 14.812 19.7952 14.6581L11.6309 10.0561Z",
    fill: "#1F232D"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgPlayButton);
export { ForwardRef as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzAiIGhlaWdodD0iMzAiIHZpZXdCb3g9IjAgMCAzMCAzMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGNpcmNsZSBjeD0iMTUiIGN5PSIxNSIgcj0iMTUiIHRyYW5zZm9ybT0ibWF0cml4KC0xIDAgMCAxIDMwIDApIiBmaWxsPSJ3aGl0ZSIgZmlsbC1vcGFjaXR5PSIwLjUiLz4KPHBhdGggZD0iTTExLjYzMDkgMTAuMDU2MUMxMS4zNTIzIDkuODk5MTMgMTEgMTAuMDkwMSAxMSAxMC4zOTgxVjE5LjYwMTlDMTEgMTkuOTA5OSAxMS4zNTIzIDIwLjEwMDkgMTEuNjMwOSAxOS45NDM5TDE5Ljc5NTIgMTUuMzQxOUMyMC4wNjgzIDE1LjE4OCAyMC4wNjgzIDE0LjgxMiAxOS43OTUyIDE0LjY1ODFMMTEuNjMwOSAxMC4wNTYxWiIgZmlsbD0iIzFGMjMyRCIvPgo8L3N2Zz4K";